import { withAuth, redirectOnAuthenticated, validateToken } from '@/utils/access_control';

import Layout from '@/templates/Layout';
import HeadlessLayout from '@/templates/HeadlessLayout';

import AppsSettings from '@/pages/AppsSettings';
import AppSettings from '@/pages/AppSettings';
import Dashboard from '@/pages/Dashboard';
import ClockedIn from '@/pages/CurrentClockedIn';
import Companies from '@/pages/Companies';
import ErrorPage from '@/pages/Error';
import Home from '@/pages/Home';
import Invitation from '@/pages/Invitation';
import InviteUsers from '@/pages/InviteUsers';
import BMSReport from '@/pages/BMSReport';
import Payroll from '@/pages/Payroll';
import Logout from '@/pages/Logout';
import MyPtos from '@/pages/MyPtos';
import MyTimesheets from '@/pages/MyTimesheets';
import NotAuthorized from '@/pages/NotAuthorized';
import PasswordReset from '@/pages/PasswordReset';
import Policy from '@/pages/Policy';
import ProfileSettings from '@/pages/ProfileSettings';
import Pto from '@/pages/Pto';
import Ptos from '@/pages/Ptos';
import Registration from '@/pages/Registration';
import Timesheet from '@/pages/Timesheet';
import Timesheets from '@/pages/Timesheets';
import TimesheetsArchive from '@/pages/TimesheetsArchive';
import UserProfile from '@/pages/UserProfile';
import Users from '@/pages/Users';
import UserCreate from '@/pages/UserCreate';

export default [
  {
    path: '/',
    component: HeadlessLayout,
    beforeEnter: validateToken,
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
      },
    ],
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/error',
        name: 'error',
        component: ErrorPage,
      },
      {
        path: '/not-authorized',
        name: 'notAuthorized',
        component: NotAuthorized,
      },
      {
        path: 'invitation',
        name: 'invitation',
        component: Invitation,
      },
      {
        path: 'login',
        redirect: '/',
        beforeEnter: redirectOnAuthenticated,
      },
      {
        path: 'logout',
        name: 'logout',
        component: Logout,
        beforeEnter: redirectOnAuthenticated,
      },
      {
        path: 'registration',
        name: 'registration',
        component: Registration,
        beforeEnter: redirectOnAuthenticated,
      },
      {
        path: 'reset-password',
        name: 'resetPassword',
        component: PasswordReset,
        beforeEnter: redirectOnAuthenticated,
      },

      {
        path: 'apps',
        name: 'appsSettings',
        component: AppsSettings,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['master']),
      },
      {
        path: 'apps/:id/invite-users',
        name: 'inviteUsers',
        component: InviteUsers,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['master']),
      },
      {
        path: 'apps/:id/settings',
        name: 'appSettings',
        component: AppSettings,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['master']),
      },
      {
        path: 'companies',
        name: 'companies',
        component: Companies,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['master']),
      },
      {
        path: 'clockedin',
        name: 'clockedin',
        component: ClockedIn,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['master', 'admin', 'manager']),
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'bmsreport',
        name: 'bmsreport',
        component: BMSReport,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'payroll',
        name: 'payroll',
        component: Payroll,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'myptos',
        name: 'myptos',
        component: MyPtos,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'mytimesheets',
        name: 'mytimesheets',
        component: MyTimesheets,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'policy',
        name: 'policy',
        component: Policy,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'profile',
        name: 'profileSettings',
        component: ProfileSettings,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(),
      },
      {
        path: 'ptos',
        name: 'ptos',
        component: Ptos,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'ptos/:id(\\d+)',
        name: 'pto',
        component: Pto,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'timesheet/:id(\\d+)',
        name: 'timesheet',
        component: Timesheet,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'timesheets',
        name: 'timesheets',
        component: Timesheets,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'timesheets/archived',
        name: 'timesheetsArchive',
        component: TimesheetsArchive,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'user/:id(\\d+)/profile',
        name: 'userProfile',
        component: UserProfile,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'users',
        name: 'users',
        component: Users,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'manager', 'officeAdmin']),
      },
      {
        path: 'user/new',
        name: 'userCreate',
        component: UserCreate,
        meta: {
          showInvalidTokenError: true,
        },
        beforeEnter: withAuth(['admin', 'master']),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js